import React from "react"
import * as classNames from "./ArticleLeftRightBlock.module.scss"
import Button from "../../../common/blocks/button/Button"
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"
import Icon from "../../../common/blocks/icon/Icon"
import { formatDate } from "../../../../../utils/formatDate"
import { Link } from "gatsby"
import { tagUrl } from "../../../../../utils/routeLib"
import Image from "../../../common/blocks/image/Image"

function ArticleLeftRightBlock({ bigTitle, isAlignLeft, url, article }) {
  return (
    <div className={"pb-8"}>
      <h2 className={classNames.title}>{bigTitle}</h2>
      <div
        className={`${classNames.ArticleContainer} ${
          isAlignLeft ? classNames.ArticleContainerReverse : ""
        }`}
      >
        <div className={classNames.articleImage}>
          <Link to={url}>
            <Image
              dataSizesPreset={"article"}
              imgSrc={article?.attributes.image?.data?.attributes.url}
              imgAlt={article?.attributes.image?.data?.attributes.alternativeText}
              imgWidth={article?.attributes.image?.data?.attributes.width}
              imgHeight={article?.attributes.image?.data?.attributes.height}
              formats={article?.attributes.image?.data?.attributes?.formats}
            />
          </Link>
        </div>
        <div className={classNames.articleContent}>
          <Link to={url}>
            <h2>{article?.attributes.title}</h2>
          </Link>
           <Link to={url} className={classNames.desciptionHover}> 
            <p>{article?.attributes.Description}</p>
           </Link> 
          <div className={classNames.tagsContainer}>
            <Swiper
              spaceBetween={10}
              slidesPerView={"auto"}
              className={classNames.tagsSwiper}
            >
              <div className={classNames.tags}>
                {article?.attributes.tags?.data?.map((tag, i) => (
                  <SwiperSlide>
                    <Button
                      key={tag}
                      aspect="tag"
                      to={tagUrl(tag.attributes.autoRoute)}
                      color="secondary"
                    >
                      #{tag.attributes.label}
                    </Button>
                  </SwiperSlide>
                ))}
              </div>
            </Swiper>
            <div className={classNames.iconContainer}>
              <div className={`${classNames.date}`}>
                <time>{formatDate(article?.attributes.publishedAt)}</time>
              </div>
              <div className={classNames.icon}>
                <Icon
                  icon="calendar"
                  color="var(--gris)"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export const name = "ArticleLeftRightBlock"

export const init = (componentData) => {
  return <ArticleLeftRightBlock key={componentData.id} tt={componentData.title} />
}

export default ArticleLeftRightBlock
